import { useContext } from "react";
import { TaskContext } from "contexts";

export default () => useContext(TaskContext);
